import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "IntegrationPage" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WhatsappIntegration = _resolveComponent("WhatsappIntegration")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.Access('Integration_Whatsapp_Read'))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["IntegrationSection", _ctx.Access('Integration_Whatsapp_Edit') ? '': 'Disabled'])
        }, [
          _createVNode(_component_WhatsappIntegration)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}